
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4JAG5", function(module, exports) {

$parcel$export(module.exports, "toChallengeRequest", function () { return $72117541598b8245$export$79b8871c3ed7cc2a; });
function $72117541598b8245$export$79b8871c3ed7cc2a(response) {
    if (!response) return null;
    return {
        "challenge-kind": response.challengeKind,
        token: {
            value: response.token
        },
        type: response.type
    };
}

});

parcelRegister("a5qoX", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaContext", function () { return $2e597c0bcbbea840$export$744a1a543fe96347; });
$parcel$export(module.exports, "RecaptchaContextProvider", function () { return $2e597c0bcbbea840$export$3f8996f6160b8ff2; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $k8slT = parcelRequire("k8slT");
const $2e597c0bcbbea840$export$2b9e9205883624e = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $2e597c0bcbbea840$export$744a1a543fe96347 = ()=>{
    const context = (0, $91i6m.useContext)($2e597c0bcbbea840$export$2b9e9205883624e);
    if (!context) throw new Error("useRecaptchaContext must be used within a RecaptchaContextProvider");
    return context;
};
const $2e597c0bcbbea840$export$3f8996f6160b8ff2 = ({ children: children, pageId: pageId, type: type, action: action, enabledProp: enabledProp })=>{
    const { isLoaded: isLoaded, enabled: enabled, errorMessage: errorMessage, component: component, fetchToken: baseFetchToken } = (0, $k8slT.useRecaptcha)({
        pageId: pageId,
        type: type,
        action: action,
        enabledProp: enabledProp
    });
    const fetchToken = (0, $91i6m.useCallback)(baseFetchToken, [
        baseFetchToken
    ]);
    const state = (0, $91i6m.useMemo)(()=>({
            isLoaded: isLoaded,
            enabled: enabled,
            errorMessage: errorMessage,
            component: component,
            fetchToken: fetchToken,
            recaptchaType: type
        }), [
        isLoaded,
        enabled,
        errorMessage,
        component,
        fetchToken,
        type
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($2e597c0bcbbea840$export$2b9e9205883624e.Provider, {
        value: state,
        children: children
    });
};

});
parcelRegister("k8slT", function(module, exports) {

$parcel$export(module.exports, "useRecaptcha", function () { return $fd41387fb9659e5c$export$f7242fdfba1703e8; });

var $91i6m = parcelRequire("91i6m");

var $aY5EN = parcelRequire("aY5EN");

var $erh2U = parcelRequire("erh2U");

var $2aGBJ = parcelRequire("2aGBJ");

var $49Pnv = parcelRequire("49Pnv");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");
const $fd41387fb9659e5c$var$noOpScoreConfig = {
    sitekey: "",
    pageId: "",
    enabled: false
};
const $fd41387fb9659e5c$var$noOpCheckboxConfig = {
    sitekey: "",
    pageId: "",
    enabled: false,
    action: ""
};
const $fd41387fb9659e5c$export$f7242fdfba1703e8 = (props)=>{
    const { pageId: pageId, type: typeFromProps, enabledProp: enabledProp = true, action: action } = props;
    const type = (0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).HOT_113002_FORCE_CHECKBOX) ? "checkbox" : typeFromProps;
    const { config: config } = $fd41387fb9659e5c$export$9b70e8251564d9ec(pageId, type, enabledProp, action);
    const isScore = type === "score";
    const isCheckbox = type === "checkbox";
    const scoreRecaptcha = (0, $erh2U.useScoreRecaptcha)(isScore ? config : $fd41387fb9659e5c$var$noOpScoreConfig);
    const checkboxRecaptcha = (0, $aY5EN.useCheckboxRecaptcha)(isCheckbox ? config : $fd41387fb9659e5c$var$noOpCheckboxConfig);
    return (0, $91i6m.useMemo)(()=>isScore ? $fd41387fb9659e5c$var$handleScore(scoreRecaptcha, action) : $fd41387fb9659e5c$var$handleCheckbox(checkboxRecaptcha), [
        isScore,
        scoreRecaptcha,
        checkboxRecaptcha,
        action
    ]);
};
function $fd41387fb9659e5c$export$9b70e8251564d9ec(pageId, type, enabledProp, action) {
    const captchaEnabledByConfig = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig.recaptchaEnable);
    const scoreSitekey = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseScoreKeySite);
    const checkboxSitekey = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseCheckboxKeySite);
    const enabled = captchaEnabledByConfig && enabledProp;
    const commonConfig = {
        pageId: pageId,
        enabled: enabled
    };
    const scoreConfig = {
        ...commonConfig,
        sitekey: scoreSitekey,
        displayBadge: false
    };
    const checkboxConfig = {
        ...commonConfig,
        sitekey: checkboxSitekey,
        action: action ?? "unknown"
    };
    return type === "score" ? {
        type: type,
        config: scoreConfig
    } : {
        type: type,
        config: checkboxConfig
    };
}
const $fd41387fb9659e5c$var$handleCheckbox = (checkboxRecaptcha)=>{
    const wrapToken = ()=>{
        if ((0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).SHOULD_FAIL_OPEN_RECAPTCHA)) return Promise.resolve({
            token: checkboxRecaptcha.token || "",
            type: "checkbox",
            challengeKind: "recaptcha"
        });
        else return Promise.resolve(checkboxRecaptcha.token ? {
            token: checkboxRecaptcha.token,
            type: "checkbox",
            challengeKind: "recaptcha"
        } : null);
    };
    const isLoaded = checkboxRecaptcha.isLoaded;
    const enabled = checkboxRecaptcha?.enabled;
    const errorMessage = checkboxRecaptcha?.error?.message ?? undefined;
    const component = checkboxRecaptcha.component;
    const onFetchToken = async ()=>{
        const response = await wrapToken();
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) {
            if ((0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).SHOULD_FAIL_OPEN_RECAPTCHA)) (0, $49Pnv.captureRecaptchaMessage)(errorMessage ?? "no token returned from checkbox recaptcha", {}, "no_token_checkbox");
            else throw new Error(errorMessage ?? "no token returned from recaptcha");
        }
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage,
        component: component
    };
};
const $fd41387fb9659e5c$var$handleScore = (scoreRecaptcha, action)=>{
    const fetchAndWrapToken = (action)=>scoreRecaptcha.fetchRecaptchaToken(action).then((token)=>{
            if ((0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).SHOULD_FAIL_OPEN_RECAPTCHA)) return {
                token: token || "",
                type: "score",
                challengeKind: "recaptcha"
            };
            else return token ? {
                token: token,
                type: "score",
                challengeKind: "recaptcha"
            } : null;
        });
    const isLoaded = scoreRecaptcha.isLoaded;
    const enabled = scoreRecaptcha?.enabled;
    const errorMessage = scoreRecaptcha?.loadRecaptchaErrorReason ?? undefined;
    const onFetchToken = async ()=>{
        const response = await fetchAndWrapToken(action);
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) {
            if ((0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).SHOULD_FAIL_OPEN_RECAPTCHA)) (0, $49Pnv.captureRecaptchaMessage)(errorMessage ?? "no token returned from score recaptcha", {}, "no_token_score");
            else throw new Error(errorMessage ?? "no token returned from recaptcha");
        }
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage
    };
};

});
parcelRegister("aY5EN", function(module, exports) {

$parcel$export(module.exports, "useCheckboxRecaptcha", function () { return $07f810a4866efebe$export$25db2ae7b91eff3b; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $1uBou = parcelRequire("1uBou");

var $49Pnv = parcelRequire("49Pnv");

var $1V2cH = parcelRequire("1V2cH");

var $c7m3x = parcelRequire("c7m3x");
const $07f810a4866efebe$export$25db2ae7b91eff3b = (config)=>{
    const [instanceId, setInstanceId] = (0, $91i6m.useState)();
    const [token, setToken] = (0, $91i6m.useState)("");
    const [isLoaded, setIsLoaded] = (0, $91i6m.useState)(false);
    const [isExpired, setIsExpired] = (0, $91i6m.useState)(false);
    const [error, setError] = (0, $91i6m.useState)();
    const { sitekey: sitekey, action: action, enabled: enabled, pageId: pageId } = config;
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const scriptLogic = (0, $1uBou.useCheckboxRecaptchaScripts)();
    const sendTrackingEvent = (0, $91i6m.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: action,
            subject: "checkbox-recaptcha",
            ...errorType && {
                attributes: {
                    hasError: true,
                    errorName: errorType
                }
            }
        });
    }, [
        analyticsClient,
        pageId
    ]);
    const handleVerify = (0, $91i6m.useCallback)((newToken)=>{
        setToken(newToken);
        setIsExpired(false);
        sendTrackingEvent("checkbox-completed");
    }, [
        sendTrackingEvent
    ]);
    const handleExpire = (0, $91i6m.useCallback)(()=>{
        setToken("");
        setIsExpired(true);
        sendTrackingEvent("expired-callback", "recaptcha-script-error");
    }, [
        sendTrackingEvent
    ]);
    const handleError = (0, $91i6m.useCallback)(()=>{
        const newError = (0, $c7m3x.RecaptchaError).fromMessage("Failed to load recaptcha script");
        setError(newError);
        (0, $49Pnv.captureRecaptchaException)(newError, {}, "no_token_checkbox");
        sendTrackingEvent("error-callback", "recaptcha-script-error");
    }, [
        sendTrackingEvent
    ]);
    const handleOnLoad = (0, $91i6m.useCallback)(()=>{
        sendTrackingEvent("loaded-recaptcha");
        setIsLoaded(true);
    }, [
        sendTrackingEvent
    ]);
    // This callback is used for rendering recaptcha into the ref associated HTML Element.
    // The recaptcha script is loaded, if not done already, and then rendered.
    const refCallback = (0, $91i6m.useCallback)(async (node)=>{
        if (!node) return;
        try {
            // Dynamically loads the recaptcha script when needed.
            await scriptLogic.injectRecaptchaScript();
            handleOnLoad();
            // Renders the recaptcha component into the given node.
            const newInstanceId = scriptLogic.getRecaptchaMethods().render(node, {
                sitekey: sitekey,
                action: action,
                callback: handleVerify,
                "expired-callback": handleExpire,
                "error-callback": handleError
            });
            setInstanceId(newInstanceId);
        } catch (error) {
            const newError = (0, $c7m3x.RecaptchaError).fromMessage("Failed to load recaptcha script");
            setError(newError);
            (0, $49Pnv.captureRecaptchaException)(newError, {}, "no_token_checkbox");
            sendTrackingEvent("load-recaptcha-failed", "recaptcha-window-error");
        }
    }, [
        scriptLogic,
        handleOnLoad,
        sitekey,
        action,
        handleVerify,
        handleExpire,
        handleError,
        sendTrackingEvent
    ]);
    const component = (0, $91i6m.useMemo)(()=>enabled ? /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
            id: "checkbox-recaptcha-hook",
            ref: refCallback
        }) : null, [
        enabled,
        refCallback
    ]);
    const reset = (0, $91i6m.useCallback)(()=>{
        if (instanceId === undefined) return;
        scriptLogic.getRecaptchaMethods().reset(instanceId);
        setToken("");
        setIsLoaded(false);
        setIsExpired(false);
    }, [
        instanceId,
        scriptLogic
    ]);
    const getResponse = (0, $91i6m.useCallback)(()=>{
        return instanceId !== undefined ? scriptLogic.getRecaptchaMethods().getResponse(instanceId) : "";
    }, [
        instanceId,
        scriptLogic
    ]);
    return {
        component: component,
        reset: reset,
        token: token,
        error: error,
        getResponse: getResponse,
        enabled: enabled,
        isLoaded: isLoaded,
        isExpired: isExpired
    };
};

});
parcelRegister("1uBou", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptchaScripts", function () { return $d1b1d46ed453d5b9$export$4b37d6e6c5707b8a; });
$parcel$export(module.exports, "useCheckboxRecaptchaScripts", function () { return $d1b1d46ed453d5b9$export$b48db21c95021cdf; });

var $49Pnv = parcelRequire("49Pnv");

var $91i6m = parcelRequire("91i6m");

var $c7m3x = parcelRequire("c7m3x");
const $d1b1d46ed453d5b9$var$RECAPTCHA_SCRIPT_DOMAIN = "www.recaptcha.net";
const $d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = "Failed to load grecaptcha enterprise.";
const $d1b1d46ed453d5b9$export$3bfe7d4134a81119 = ()=>window.grecaptcha?.enterprise;
/**
 * Loads the reCAPTCHA script if it hasn't been loaded already.
 *
 * Loading states:
 *  0. Script <src> element does not exist on the DOM.
 *  1. Script is asynchronously downloading and the reCAPTCHA methods are not available yet.
 *  2. Script has been downloaded and a 'load' event is fired for the DOM element and the reCAPTCHA methods are now available.
 *  3. Google fires a 'ready' event when the reCAPTCHA methods are available.
 *      Recaptcha can be considered to be fully ready to use at this point.
 *  4. Extra dependencies and scripts are downloaded asynchronously.
 *      This extra step should not be relevant to checkbox or score, but may be relevant for invisible.
 */ // Keep a track of all loaded scripts so the promise can be re-used by different React components/hooks:
const $d1b1d46ed453d5b9$var$scriptCache = new Map();
const $d1b1d46ed453d5b9$export$62fae4128d19343d = (scriptId)=>$d1b1d46ed453d5b9$var$scriptCache.delete(scriptId);
const $d1b1d46ed453d5b9$export$c80de0a5a6afcd7c = async (scriptId, scriptSrc)=>{
    let scriptPromise = $d1b1d46ed453d5b9$var$scriptCache.get(scriptId);
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject)=>{
            const scriptElement = document.createElement("script");
            scriptElement.id = scriptId;
            scriptElement.src = `https://${$d1b1d46ed453d5b9$var$RECAPTCHA_SCRIPT_DOMAIN}${scriptSrc}`;
            scriptElement.async = true;
            scriptElement.defer = true;
            scriptElement.addEventListener("load", ()=>{
                if (window && window.grecaptcha && window.grecaptcha.enterprise) // reCAPTCHA script was injected and library 'finished' loading once ready() completes
                $d1b1d46ed453d5b9$export$3bfe7d4134a81119().ready(()=>resolve());
                else {
                    (0, $49Pnv.captureErrorMessage)($d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
                    reject((0, $c7m3x.RecaptchaError).fromMessage($d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE));
                }
            });
            // investigate - error undefined
            scriptElement.addEventListener("error", (errorEvent)=>{
                (0, $49Pnv.captureException)(errorEvent.error);
                reject((0, $c7m3x.RecaptchaError).fromError(errorEvent.error || new Error($d1b1d46ed453d5b9$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE)));
            });
            document.head.appendChild(scriptElement);
        });
        $d1b1d46ed453d5b9$var$scriptCache.set(scriptId, scriptPromise);
    }
    return scriptPromise;
};
const $d1b1d46ed453d5b9$export$a0a588829684d44 = (scriptId)=>{
    const script = document.getElementById(scriptId);
    return script !== null;
};
const $d1b1d46ed453d5b9$export$924e44702e93d253 = (scriptId)=>{
    const id = `${scriptId}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement("style");
    styleElement.id = id;
    styleElement.innerText = ".grecaptcha-badge { visibility: hidden; }";
    document.head.appendChild(styleElement);
};
const $d1b1d46ed453d5b9$export$684246aaf6783333 = (scriptId)=>{
    const scriptElement = document.getElementById(scriptId);
    if (scriptElement) scriptElement.remove();
};
const $d1b1d46ed453d5b9$export$42b99ab155dad274 = (scriptId)=>{
    const styleElement = document.getElementById(`${scriptId}-styles`);
    if (styleElement) styleElement.remove();
};
const $d1b1d46ed453d5b9$export$f124d412b77f93b3 = ()=>{
    document.querySelectorAll(".grecaptcha-badge").forEach((element)=>element.remove());
};
const $d1b1d46ed453d5b9$export$4b37d6e6c5707b8a = ({ sitekey: sitekey })=>{
    const scriptSrc = `/recaptcha/enterprise.js?render=${sitekey}`;
    return (0, $91i6m.useMemo)(()=>({
            injectRecaptchaScript: ()=>$d1b1d46ed453d5b9$export$c80de0a5a6afcd7c(sitekey, scriptSrc),
            getRecaptchaMethods: ()=>$d1b1d46ed453d5b9$export$3bfe7d4134a81119(),
            hideRecaptchaBadge: ()=>$d1b1d46ed453d5b9$export$924e44702e93d253(sitekey),
            unloadRecaptcha () {
                $d1b1d46ed453d5b9$export$684246aaf6783333(sitekey);
                $d1b1d46ed453d5b9$export$42b99ab155dad274(sitekey);
                $d1b1d46ed453d5b9$export$f124d412b77f93b3();
                $d1b1d46ed453d5b9$export$62fae4128d19343d(sitekey);
            }
        }), [
        sitekey,
        scriptSrc
    ]);
};
const $d1b1d46ed453d5b9$export$b48db21c95021cdf = ()=>{
    const scriptId = "checkbox-recaptcha";
    const scriptSrc = "/recaptcha/enterprise.js?render=explicit";
    return (0, $91i6m.useMemo)(()=>({
            injectRecaptchaScript: ()=>$d1b1d46ed453d5b9$export$c80de0a5a6afcd7c(scriptId, scriptSrc),
            getRecaptchaMethods: ()=>$d1b1d46ed453d5b9$export$3bfe7d4134a81119()
        }), []);
};

});
parcelRegister("c7m3x", function(module, exports) {

$parcel$export(module.exports, "RecaptchaError", function () { return $d54c95a9295aefb7$export$e037dc82f45cc746; });
class $d54c95a9295aefb7$export$e037dc82f45cc746 extends Error {
    constructor(message){
        super(message);
        this.name = "RecaptchaError";
    }
    static fromError(error) {
        const instance = new $d54c95a9295aefb7$export$e037dc82f45cc746(error.message);
        instance.stack = error.stack;
        return instance;
    }
    static fromMessage(message) {
        const instance = new $d54c95a9295aefb7$export$e037dc82f45cc746(message);
        instance.stack = new Error().stack;
        return instance;
    }
}

});



parcelRegister("erh2U", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptcha", function () { return $23231c7e046cbc39$export$afce2c1d72c48fc5; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $49Pnv = parcelRequire("49Pnv");

var $1uBou = parcelRequire("1uBou");

var $c7m3x = parcelRequire("c7m3x");

var $3f4xr = parcelRequire("3f4xr");

var $kpg9c = parcelRequire("kpg9c");
const $23231c7e046cbc39$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE = "Failed to invoke grecaptcha execute function as it is not ready.";
const $23231c7e046cbc39$export$afce2c1d72c48fc5 = (config)=>{
    const [loadRecaptchaErrorReason, setLoadRecaptchaErrorReason] = (0, $91i6m.useState)();
    const [isLoaded, setIsLoaded] = (0, $91i6m.useState)(false);
    const scriptInitializationRef = (0, $91i6m.useRef)();
    const { sitekey: sitekey, enabled: enabled, displayBadge: displayBadge = false, pageId: pageId } = config;
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const scriptLogic = (0, $1uBou.useScoreRecaptchaScripts)({
        sitekey: sitekey
    });
    const sendTrackingEvent = (0, $91i6m.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: action,
            subject: "score-recaptcha",
            ...errorType && {
                attributes: {
                    hasError: true,
                    errorName: errorType
                }
            }
        });
    }, [
        analyticsClient,
        pageId
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (!enabled) return;
        const initRecaptcha = async ()=>{
            try {
                await scriptLogic.injectRecaptchaScript();
                sendTrackingEvent("loaded-recaptcha");
                if (!displayBadge) scriptLogic.hideRecaptchaBadge();
                setIsLoaded(true);
            } catch (error) {
                const errorMessage = String(error);
                setLoadRecaptchaErrorReason(errorMessage);
                (0, $49Pnv.captureException)(error);
                sendTrackingEvent("load-recaptcha-failed", "recaptcha-script-error");
            }
        };
        scriptInitializationRef.current = initRecaptcha();
        return ()=>{
            scriptLogic.unloadRecaptcha();
            setLoadRecaptchaErrorReason(undefined);
            scriptInitializationRef.current = undefined;
        };
    }, [
        displayBadge,
        sitekey,
        pageId,
        enabled,
        analyticsClient,
        sendTrackingEvent,
        scriptLogic
    ]);
    const fetchRecaptchaToken = (0, $91i6m.useCallback)(async (action)=>{
        if (!enabled) return "";
        if (scriptInitializationRef.current) await scriptInitializationRef.current;
        if (!window?.grecaptcha?.enterprise?.execute) {
            if ((0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).SHOULD_FAIL_OPEN_RECAPTCHA)) {
                (0, $49Pnv.captureRecaptchaException)((0, $c7m3x.RecaptchaError).fromMessage($23231c7e046cbc39$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE), {}, "no_token_score");
                sendTrackingEvent("get-recaptcha-token", "recaptcha-window-error");
                return "";
            } else {
                (0, $49Pnv.captureErrorMessage)($23231c7e046cbc39$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE);
                sendTrackingEvent("get-recaptcha-token", "recaptcha-window-error");
                throw (0, $c7m3x.RecaptchaError).fromMessage($23231c7e046cbc39$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE);
            }
        }
        try {
            return await window.grecaptcha.enterprise.execute(sitekey, {
                action: action
            });
        } catch (err) {
            if ((0, $3f4xr.checkFeatureGate)((0, $kpg9c.AidFrontendFeatureGate).SHOULD_FAIL_OPEN_RECAPTCHA)) {
                (0, $49Pnv.captureRecaptchaException)((0, $c7m3x.RecaptchaError).fromError(err), {}, "no_token_score");
                sendTrackingEvent("get-recaptcha-token", "recaptcha-script-error");
                return "";
            } else {
                (0, $49Pnv.captureException)(err);
                sendTrackingEvent("get-recaptcha-token", "recaptcha-script-error");
                throw (0, $c7m3x.RecaptchaError).fromError(err);
            }
        }
    }, [
        enabled,
        sendTrackingEvent,
        sitekey
    ]);
    return {
        isLoaded: isLoaded,
        fetchRecaptchaToken: fetchRecaptchaToken,
        loadRecaptchaErrorReason: loadRecaptchaErrorReason,
        enabled: enabled
    };
};

});




//# sourceMappingURL=page.a111e62b.js.map
